import {PageSubTitle} from "../../components/CummonComponents/PageSubTitle/PageSubTitle";
import {PageTitle} from "../../components/CummonComponents/PageTitle/PageTitle";
import {WeOffer} from "../../components/SubscibePageComponents/WeOffer/WeOffer";
import {ContactLink} from "../../components/CummonComponents/ContactLink/ContactLink";
import {useSubscribes, useImageUrl} from "../../queries";
import {Loading} from "../../components/CommonComponents/Loading/Loading";
import {Helmet} from "react-helmet-async";
import {APP_NAME} from "../../utils/constants";

export const Subscribe = () => {
    const {data, isLoading} = useSubscribes();
    const headerImageUrl = useImageUrl(data?.header_block_image);

    return (
        <>
            <Helmet>
                <title>Subscribe | {APP_NAME}</title>
            </Helmet>
            {isLoading ? (
                <Loading />
            ) : !data ? (
                null
            ) : (
                <>
                    <PageSubTitle>
                        {data.header_title}
                    </PageSubTitle>
                    <PageTitle image={headerImageUrl}>
                        {data.header_block_title}
                    </PageTitle>
                    <WeOffer data={data}/>
                    <ContactLink
                        titleText={data.footer_title}
                        btnText={data.footer_button?.title || ""}
                        href={data.footer_button?.href}
                    />
                </>
            )}
        </>
    )
}
